<template>
  <b-card >
    <b-card-title>
      <span v-html="data.title" class="f-default" />
    </b-card-title>
    <b-card-text>
     <h4> <span v-html="data.content" class="f-default"/></h4>
     <slot name="other_value" />
     <slot name="other_value_2" />
    </b-card-text>
  </b-card>
</template>

<script>

  export default  {
    props: {
     data:{
       type: Object
     }
    },
 
}


</script>

<style scoped lang="scss">
  .card-title{
    font-size: 11px;
  }
  .card{
    border: none !important;
  }
</style>
